import React, { ChangeEvent, useState, ComponentType, useEffect } from 'react';

import api from '../../services/api';
import { useNavigate, useParams } from 'react-router-dom';

import Avatar from '@mui/material/Avatar';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import Link from '@mui/material/Link';
import Box from '@mui/material/Box';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import Alert from '@mui/material/Alert/Alert';
import { LoadingButton } from '@mui/lab';
import toast from 'react-hot-toast';

interface Props {
  /* userData: any;
  resetPasswordData: (value: boolean | {}) => void;*/
}

type Credentials = { name: string; password: string };

function Copyright(props: any) {
  return (
    <Typography
      variant="body2"
      color="text.secondary"
      align="center"
      {...props}
    >
      {'Copyright © '}
      <Link color="inherit" href="https://stagemporium.com/">
        stagemporium.com
      </Link>{' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  );
}

export const CreateNewPasswordPage: ComponentType<Props> = ({}) => {
  const [password, setPassword] = useState('');
  const [passwordAgain, setPasswordAgain] = useState('');
  const [loading, setLoading] = useState(false);
  const { passwordResetKey } = useParams();
  const [resetPasswordData, setResetPasswordData] = useState<any>(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (passwordResetKey !== null) {
      api
        .post(`/reset-password-validate`, { key: passwordResetKey }, true)
        .then((res: any) => {
          setResetPasswordData(res);
        })
        .catch((err: any) => {
          toast.error('Invalid token');
        });
    }
  }, []);

  const handleSubmit = async (): Promise<void> => {
    if (!password) {
      toast.error('Please enter your password');
    } else if (password.length < 4) {
      toast.error('The password must be at least 4 characters long');
    } else if (!passwordAgain) {
      toast.error('Please enter your password again');
    } else if (passwordAgain !== password) {
      toast.error('Please enter your password again');
    } else {
      setLoading(true);

      api
        .post(
          `/reset-password/${resetPasswordData.id}`,
          {
            password: password,
            password_again: passwordAgain,
            key: resetPasswordData?.password_reset_key,
          },
          true
        )
        .then((res: any) => {
          setResetPasswordData(false);
          setLoading(false);

          toast.success('Successfully set password');

          navigate('/login');
        })
        .catch((err: any) => {
          toast.error('Invalid credentials');
          setLoading(false);
        });
    }
  };

  const defaultTheme = createTheme();

  return (
    <ThemeProvider theme={defaultTheme}>
      <Container
        component="main"
        maxWidth="xs"
        sx={{
          background: '#fff',
          height: {
            xs: '100vh',
            md: 'auto',
          },
          borderRadius: {
            md: '15px',
          },
          boxShadow: {
            md: '0px 2px 15px -9px #0000006b',
          },
          mt: {
            md: '100px',
          },
        }}
      >
        <CssBaseline />
        <Box
          sx={{
            marginTop: 8,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <Avatar
            sx={{ m: 1, bgcolor: 'secondary.main' }}
            src={
              'https://www.stagemporium.com/wp-content/themes/stagsemporium/images/logo.png'
            }
          >
            <LockOutlinedIcon />
          </Avatar>
          <Typography component="h1" variant="h5">
            Reset Password
          </Typography>

          {resetPasswordData && (
            <Box component="form" noValidate sx={{ mt: 1 }}>
              <TextField
                margin="normal"
                required
                fullWidth
                label="Email Address"
                name="email"
                defaultValue={resetPasswordData?.email}
                disabled={true}
              />
              <TextField
                label="New Password"
                fullWidth={true}
                variant="outlined"
                disabled={loading}
                onChange={({
                  target: { value },
                }: ChangeEvent<HTMLInputElement>) => setPassword(value)}
                margin="normal"
                name="password"
                type="password"
              />

              <TextField
                margin="normal"
                id="password"
                label=" New Password Again"
                fullWidth={true}
                variant="outlined"
                disabled={loading}
                onChange={({
                  target: { value },
                }: ChangeEvent<HTMLInputElement>) => setPasswordAgain(value)}
                type={'password'}
              />

              <LoadingButton
                loading={loading}
                fullWidth
                variant="contained"
                sx={{ mt: 3, mb: 2 }}
                onClick={() => {
                  handleSubmit();
                }}
              >
                Reset Password
              </LoadingButton>
            </Box>
          )}
        </Box>
        <Copyright sx={{ mt: 6, mb: 4 }} />
      </Container>
    </ThemeProvider>
  );
};
